<div class="main-wrapper" id="payment-method">
    <div *ngIf="displayErrorMessage.length" class="form-group">
        <div class="error-message-center">
            {{displayErrorMessage}}</div>
    </div>
    <div *ngIf="hasTenders" class="container">
        <div class="row mt-5">
            <div class="no-pad col-10">
                <app-update-plan
                        [changeCode]="changeCode"
                        [currentEnvironment]="currentEnvironment"
                        [userEnrollmentDetails]="userEnrollmentDetails"
                        [retentionPlanDiscount]="retentionPlanDiscount"
                        [tenderInfo]="tenderInfo"
                        [termsID]="termsID"
                        [userInfo]="userInfo">
                </app-update-plan>
            </div>
        </div>
    </div>
</div>


